<template>
  <span v-if="lastUpdated" class="updated-text">
    <strong>{{ $t('scenarioManagementPanel.updated') }}: </strong>
    {{ formatDate(lastUpdated, getDateFormats.longWithTime) }}
  </span>
</template>

<script>
import { useDayjs } from '@/composables/use-dayjs';
import { useContextStore } from '@/stores/context';
import { mapState } from 'pinia';

export default {
  props: {
    lastUpdated: {
      required: false,
      type: String,
      default: null,
    },
  },
  setup() {
    const { formatDate } = useDayjs();

    return { formatDate };
  },
  computed: { ...mapState(useContextStore, ['getDateFormats']) },
};
</script>
